import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import PricingCard from '../pricing-card';

const PricingCarousel = ({
	plans,
	billingCycle,
	selectedPlanId,
	selectedStudioSeatId,
	onSeatChange,
	onSelectPlan
}) => {
	const [activeSlide, setActiveSlide] = useState(1);
	return (
		<div className="onboarding-plans-carousel">
			<Swiper
				spaceBetween={16}
				initialSlide={1}
				slidesPerView={1.08}
				centeredSlides
				pagination={{ clickable: false }}
				modules={[Pagination]}
				onSlideChange={swiper => setActiveSlide(swiper.activeIndex)}
				className="onboarding-pricing-mobile"
			>
				{plans.map((plan, index) => (
					<SwiperSlide key={plan.id} className={index === activeSlide ? 'is-active' : 'is-blurred'}>
						<PricingCard
							plan={plan}
							billingCycle={billingCycle}
							isMostPopular={index === 1}
							isSelected={selectedPlanId === (plan.hasSeatSelection ? selectedStudioSeatId : plan.id)}
							selectedSeatId={selectedStudioSeatId}
							onSeatChange={seatId => onSeatChange?.(seatId, plan)}
							onSelectPlan={onSelectPlan}
							isMobile
						/>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default PricingCarousel;
